import _regeneratorRuntime from "/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncGeneratorDelegate from "/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncGeneratorDelegate";
import _awaitAsyncGenerator from "/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import _asyncIterator from "/Users/laurens/apps/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncIterator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(packIterSync);

import { Packr } from './pack.js';
import { Unpackr } from './unpack.js';
/**
 * Given an Iterable first argument, returns an Iterable where each value is packed as a Buffer
 * If the argument is only Async Iterable, the return value will be an Async Iterable.
 * @param {Iterable|Iterator|AsyncIterable|AsyncIterator} objectIterator - iterable source, like a Readable object stream, an array, Set, or custom object
 * @param {options} [options] - msgpackr pack options
 * @returns {IterableIterator|Promise.<AsyncIterableIterator>}
 */

export function packIter(objectIterator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!objectIterator || typeof objectIterator !== 'object') {
    throw new Error('first argument must be an Iterable, Async Iterable, or a Promise for an Async Iterable');
  } else if (typeof objectIterator[Symbol.iterator] === 'function') {
    return packIterSync(objectIterator, options);
  } else if (typeof objectIterator.then === 'function' || typeof objectIterator[Symbol.asyncIterator] === 'function') {
    return packIterAsync(objectIterator, options);
  } else {
    throw new Error('first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a Promise');
  }
}

function packIterSync(objectIterator, options) {
  var packr, _iterator3, _step3, value;

  return _regeneratorRuntime.wrap(function packIterSync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          packr = new Packr(options);
          _iterator3 = _createForOfIteratorHelper(objectIterator);
          _context.prev = 2;

          _iterator3.s();

        case 4:
          if ((_step3 = _iterator3.n()).done) {
            _context.next = 10;
            break;
          }

          value = _step3.value;
          _context.next = 8;
          return packr.pack(value);

        case 8:
          _context.next = 4;
          break;

        case 10:
          _context.next = 15;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);

          _iterator3.e(_context.t0);

        case 15:
          _context.prev = 15;

          _iterator3.f();

          return _context.finish(15);

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2, 12, 15, 18]]);
}

function packIterAsync(_x, _x2) {
  return _packIterAsync.apply(this, arguments);
}
/**
 * Given an Iterable/Iterator input which yields buffers, returns an IterableIterator which yields sync decoded objects
 * Or, given an Async Iterable/Iterator which yields promises resolving in buffers, returns an AsyncIterableIterator.
 * @param {Iterable|Iterator|AsyncIterable|AsyncIterableIterator} bufferIterator
 * @param {object} [options] - unpackr options
 * @returns {IterableIterator|Promise.<AsyncIterableIterator}
 */


function _packIterAsync() {
  _packIterAsync = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(objectIterator, options) {
    var packr, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            packr = new Packr(options);
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context2.prev = 3;
            _iterator = _asyncIterator(objectIterator);

          case 5:
            _context2.next = 7;
            return _awaitAsyncGenerator(_iterator.next());

          case 7:
            _step = _context2.sent;
            _iteratorNormalCompletion = _step.done;
            _context2.next = 11;
            return _awaitAsyncGenerator(_step.value);

          case 11:
            _value = _context2.sent;

            if (_iteratorNormalCompletion) {
              _context2.next = 19;
              break;
            }

            value = _value;
            _context2.next = 16;
            return packr.pack(value);

          case 16:
            _iteratorNormalCompletion = true;
            _context2.next = 5;
            break;

          case 19:
            _context2.next = 25;
            break;

          case 21:
            _context2.prev = 21;
            _context2.t0 = _context2["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 25:
            _context2.prev = 25;
            _context2.prev = 26;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context2.next = 30;
              break;
            }

            _context2.next = 30;
            return _awaitAsyncGenerator(_iterator.return());

          case 30:
            _context2.prev = 30;

            if (!_didIteratorError) {
              _context2.next = 33;
              break;
            }

            throw _iteratorError;

          case 33:
            return _context2.finish(30);

          case 34:
            return _context2.finish(25);

          case 35:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[3, 21, 25, 35], [26,, 30, 34]]);
  }));
  return _packIterAsync.apply(this, arguments);
}

export function unpackIter(bufferIterator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!bufferIterator || typeof bufferIterator !== 'object') {
    throw new Error('first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a promise');
  }

  var unpackr = new Unpackr(options);
  var incomplete;

  var parser = function parser(chunk) {
    var yields; // if there's incomplete data from previous chunk, concatinate and try again

    if (incomplete) {
      chunk = Buffer.concat([incomplete, chunk]);
      incomplete = undefined;
    }

    try {
      yields = unpackr.unpackMultiple(chunk);
    } catch (err) {
      if (err.incomplete) {
        incomplete = chunk.slice(err.lastPosition);
        yields = err.values;
      } else {
        throw err;
      }
    }

    return yields;
  };

  if (typeof bufferIterator[Symbol.iterator] === 'function') {
    return /*#__PURE__*/_regeneratorRuntime.mark(function iter() {
      var _iterator4, _step4, value;

      return _regeneratorRuntime.wrap(function iter$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(bufferIterator);
              _context3.prev = 1;

              _iterator4.s();

            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context3.next = 8;
                break;
              }

              value = _step4.value;
              return _context3.delegateYield(parser(value), "t0", 6);

            case 6:
              _context3.next = 3;
              break;

            case 8:
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t1 = _context3["catch"](1);

              _iterator4.e(_context3.t1);

            case 13:
              _context3.prev = 13;

              _iterator4.f();

              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, iter, null, [[1, 10, 13, 16]]);
    })();
  } else if (typeof bufferIterator[Symbol.asyncIterator] === 'function') {
    return function () {
      var _iter = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, value;

        return _regeneratorRuntime.wrap(function _callee2$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _context4.prev = 2;
                _iterator2 = _asyncIterator(bufferIterator);

              case 4:
                _context4.next = 6;
                return _awaitAsyncGenerator(_iterator2.next());

              case 6:
                _step2 = _context4.sent;
                _iteratorNormalCompletion2 = _step2.done;
                _context4.next = 10;
                return _awaitAsyncGenerator(_step2.value);

              case 10:
                _value2 = _context4.sent;

                if (_iteratorNormalCompletion2) {
                  _context4.next = 17;
                  break;
                }

                value = _value2;
                return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(parser(value)), _awaitAsyncGenerator), "t0", 14);

              case 14:
                _iteratorNormalCompletion2 = true;
                _context4.next = 4;
                break;

              case 17:
                _context4.next = 23;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t1 = _context4["catch"](2);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t1;

              case 23:
                _context4.prev = 23;
                _context4.prev = 24;

                if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                  _context4.next = 28;
                  break;
                }

                _context4.next = 28;
                return _awaitAsyncGenerator(_iterator2.return());

              case 28:
                _context4.prev = 28;

                if (!_didIteratorError2) {
                  _context4.next = 31;
                  break;
                }

                throw _iteratorError2;

              case 31:
                return _context4.finish(28);

              case 32:
                return _context4.finish(23);

              case 33:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee2, null, [[2, 19, 23, 33], [24,, 28, 32]]);
      }));

      function iter() {
        return _iter.apply(this, arguments);
      }

      return iter;
    }()();
  }
}
export var decodeIter = unpackIter;
export var encodeIter = packIter;